/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MitarbeiterDto } from '../../models/mitarbeiter-dto';

export interface GetMitarbeiterByUserId$Plain$Params {

/**
 * User ID des Mitarbeiters der geholt werden soll
 */
  userId: string;
}

export function getMitarbeiterByUserId$Plain(http: HttpClient, rootUrl: string, params: GetMitarbeiterByUserId$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<MitarbeiterDto>> {
  const rb = new RequestBuilder(rootUrl, getMitarbeiterByUserId$Plain.PATH, 'get');
  if (params) {
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MitarbeiterDto>;
    })
  );
}

getMitarbeiterByUserId$Plain.PATH = '/v1/mitarbeiter/userId/{userId}';
